import { UserFeatures } from 'types/users.types';
import useGetCurrentCustomerData from './Authentication/useGetCurrentCustomerData';

export const useIsFeatureEligible = (feature: UserFeatures): boolean => {
  const { data: user } = useGetCurrentCustomerData();
  return !!user?.featureFlags?.includes?.(feature);
};

// TODO: Remove this hook and its usages once MMF feature is confirmed stable
export const useIsMinFinDocEligible = (): boolean => {
  return true;
};
